import { request, Response } from '../utils';
import { Session } from '../types';

export const updateAccount = (body: {
  session: Session;
  bio: string;
}): Response<null> => request('update-account', body);
